'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('@most/create');

var fromFuture = function fromFuture(future) {
  return (0, _create.create)(function (add, end, err) {
    future.fork(err, function (data) {
      add(data);
      end();
    });
  });
};

exports.default = fromFuture;